import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography } from '@mui/material';
import { Agreement, agreementService } from '../services/agreementService';
import { AgreementSign } from './AgreementModal';

interface AgreementGateProps {
  children: React.ReactNode;
}

export const AgreementGate: React.FC<AgreementGateProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [pendingAgreements, setPendingAgreements] = useState<Agreement[]>([]);
  const [currentAgreementIndex, setCurrentAgreementIndex] = useState(0);

  const loadPendingAgreements = async () => {
    try {
      setLoading(true);
      const agreements = await agreementService.getPendingAgreements();
      setPendingAgreements(agreements);
      setCurrentAgreementIndex(0);
    } catch (_err) {
      // On error, don't block the app UI
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPendingAgreements();
  }, []);

  const handleAgreementSigned = () => {
    if (currentAgreementIndex < pendingAgreements.length - 1) {
      setCurrentAgreementIndex(currentAgreementIndex + 1);
    } else {
      loadPendingAgreements();
    }
  };

  if (!loading && pendingAgreements.length > 0) {
    const currentAgreement = pendingAgreements[currentAgreementIndex];
    return (
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Paper elevation={3} sx={{ p: 3, mb: 3, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom color="primary">
            Agreement Required
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            Before you can proceed, you must review and sign the required agreement(s).
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Agreement {currentAgreementIndex + 1} of {pendingAgreements.length}: <strong>{currentAgreement?.title}</strong>
          </Typography>
        </Paper>

        <AgreementSign agreement={currentAgreement} onSigned={handleAgreementSigned} />
      </Container>
    );
  }

  // Render app normally while checking or when nothing pending
  return <>{children}</>;
};
